
import { NgModule } from '@angular/core';
import { ReadMoreDirective } from './directives/read-more.directive';

@NgModule({
    imports: [
    ],
    declarations: [
      ReadMoreDirective
    ],
    exports: [
      ReadMoreDirective
    ]
})
export class ReadMoreModule { }
